module.exports = __webpack_public_path__ + "assets/img/yyindex-7.39ebae10.png";